import { BrowserRouter, Route, Switch } from "react-router-dom";
// import Header from './components/Header';
// import Footer from './components/Footer';
import MainContainer from './components/Home/MainContainer';
import Vip from "./components/Vip/Vip";
import Revoke from "./components/Revoke/Revoke";
import Pricing from "./components/Pricing/Pricing";
import Verify from "./components/Verification/Verify";
import FreeTrial from "./components/FreeTrial/FreeTrial";
import Contact from "./components/Contact";
import Referral from "./components/Referral/Referral";
import Faq from "./components/Faq";
// import ThirdSection from './components/ThirdSection';
import WalletProvider from "./components/WalletProvider";
import './App.css';

function App() {
  return (
    <div className="App">
        <WalletProvider>
            {/* <Header/> */}
            <BrowserRouter forceRefresh={true}>
				<Switch>
					<Route exact path="/">
                        <MainContainer/>
					</Route>
                    <Route path="/vip">
                        <Vip/>
					</Route>
                    <Route path="/revoke">
                        <Revoke/>
					</Route>
                    <Route path="/pricing">
                        <Pricing/>
					</Route>
                    <Route path="/verification">
                        <Verify/>
					</Route>
                      <Route path="/free-trial">
                        <FreeTrial/>
					</Route> 
                    <Route path="/contact-us">
                        <Contact/>
					</Route>
                    <Route path="/referral">
                        <Referral/>
					</Route>
                    <Route path="/faq">
                        <Faq/>
					</Route>
                </Switch>
            </BrowserRouter>
            
        </WalletProvider>
        
        {/* <Footer/> */}
    </div>
  );
}

export default App;
